module.exports = __webpack_public_path__ + "media/bootstrap-icons/camera-video-5219a6bb.svg";